import React from "react";
import NavBar from "component/NavBar";
import Footer from "component/Footer";
import Partner from "component/Partner";
import Phone from "component/Phone";
import ImageSlider from "component/ImageSlider";
import Services from "component/Services";
import Welcome from "component/Welcome";
import CTASection from "component/CTASection";

const Home = () => {
  return (
    <>
      <Phone />
      <NavBar />
      <ImageSlider />
      <Welcome />
      <Services />
      <CTASection />
      <Partner />
      <Footer />
    </>
  );
};

export default Home;
